import { cn } from '@/design-system/utils/cn';
import { Button } from '@/design-system';
import { Plug, MessageSquare, Sparkles, Settings, Wallet } from 'lucide-react';

export const SETTINGS_SECTIONS = [
  { id: 'general', label: 'Geral', icon: Settings },
  { id: 'financial', label: 'Financeira', icon: Wallet },
  { id: 'channels', label: 'Canais', icon: MessageSquare },
  { id: 'ai', label: 'Inteligência Artificial', icon: Sparkles },
  { id: 'integrations', label: 'Integrações', icon: Plug },
] as const;

export type SettingsSectionId = (typeof SETTINGS_SECTIONS)[number]['id'];

interface SettingsSidebarProps {
  activeSection: SettingsSectionId;
  onSectionChange: (sectionId: SettingsSectionId) => void;
}

export function SettingsSidebar({ activeSection, onSectionChange }: SettingsSidebarProps) {
  return (
    <aside className="flex w-48 shrink-0 flex-col overflow-hidden border-r border-gray-200 bg-white">
      <nav className="flex-1">
        {SETTINGS_SECTIONS.map((section) => {
          const Icon = section.icon;
          const isActive = activeSection === section.id;

          return (
            <Button variant="ghost" size="sm"
              key={section.id}
              type="button"
              onClick={() => onSectionChange(section.id)}
              aria-pressed={isActive}
              className={cn(
                'h-auto flex w-full items-center justify-start gap-3 rounded-none px-5 py-4 text-left transition-colors',
                isActive
                  ? 'bg-primary/10 font-medium text-primary'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              )}
            >
              <Icon className="h-5 w-5 shrink-0" />
              <span className="text-sm">{section.label}</span>
            </Button>
          );
        })}
      </nav>
    </aside>
  );
}
